<p-dialog
  header="Allocate Driver"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShow)="onShow()"
  [modal]="true"
  [style]="{ width: '800px' }"
>
  <div class="ui-grid">
    <div class="ui-grid-row" style="margin-bottom: 5px">Select task</div>
    <div class="ui-grid-row">
      <p-table
        selectionMode="single"
        [value]="noDriverTasks"
        [responsive]="true"
        rowHover="true"
        resizableColumns="true"
        [(selection)]="selectedTask"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Latest Pickup</th>
            <th>Latest Drop-Off</th>
            <th>Movement Type</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.pickupLocation.primaryAddress }}</td>
            <td>{{ item.dropoffLocation.primaryAddress }}</td>
            <td>{{ item.pickupLatestDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
            <td>{{ item.dropoffLatestDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
            <td>{{ item.taskType.name }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="ui-grid-row" style="margin-top: 20px">
      <div class="ui-g-6">
        <div class="ui-grid-col-4"><label>Driver</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown
            name="dialogDrivers"
            [options]="driverSelectItems"
            [(ngModel)]="selectedDriverId"
            [style]="{ width: '200px', position: 'fixed' }"
            placeholder="Select driver"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="allocateDriver()"
      label="Allocate"
      [disabled]="!selectedDriverId || !selectedTask"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="visibleChange.emit(false)"
    ></button>
  </div>
</p-dialog>

<p-confirmDialog #cd key="allocate-driver" closable="false" [style]="{ width: '425px' }">
  <p-footer>
    <button type="button" pButton label="No" (click)="cd.reject()"></button>
    <button type="button" pButton class="ui-button" label="Yes" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
